import { AUTH_TOKEN_KEY } from 'constant/auth';

export const setAuthToken = token =>
  localStorage.setItem(AUTH_TOKEN_KEY, token);

export const getAuthToken = () => localStorage.getItem(AUTH_TOKEN_KEY);
